import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const agreementApi = createApi({
    reducerPath:"agreementApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API + "services/agreement",
         prepareHeaders: (headers, { getState }) => {
      const token =
        getState()?.userSlice?.token || localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
    }),
    tagTypes: ['Agreement'],

    endpoints: (builder)=>({
        createAgreement: builder.mutation({
            query:({ ...body })=>{
                const payload = { ...body };
             return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Agreement"],
        }),

        getAgreement: builder.query({
      query: () => ({
        url: ``,
        method: "GET",
      }),
    }),
        getOneAgreement: builder.query({
      query: ({id}) => ({
        url: `/${id}`,
        method: "GET",
      }),
    }),
       cancelAgreement: builder.mutation({
            query:({ response, id })=>{
             
             return {
          url: `/${id}`,
          method: "DELETE",
          // body: {response},
        };
      },
      invalidatesTags: ["Agreement"],
        }),
     agreementFinalRespond: builder.mutation({
            query:({ response, id })=>{
             
             return {
          url: `/${id}/respond`,
          method: "POST",
          body: {response},
        };
      },
      invalidatesTags: ["Agreement"],
        }),
    })
})

export const {useCreateAgreementMutation, useGetAgreementQuery, useAgreementFinalRespondMutation ,useGetOneAgreementQuery,useCancelAgreementMutation} = agreementApi